import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getSigninPath, isSessionValid } from "../utils/authService";
import { Config } from "../.env.js";
import { getSigninUrl } from "../utils/sessionKeeper";

// const ProtectedRoute = ({ allowedRoles = null }) => {
//   //   const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
//   const token = localStorage.getItem("token");
//   const userRole = localStorage.getItem("userRole") || "";
//   const location = useLocation();

//   // If no allowedRoles are specified, allow all authenticated users
//   const isAuthorized = allowedRoles ? allowedRoles.includes(userRole) : true;

//   // Check if user is authenticated and has the right role
//   return token && isAuthorized ? (
//     <Outlet />
//   ) : (
//     <Navigate
//       to={
//         location.pathname === "/application-form"
//           ? "/influencer-login"
//           : "/"
//       }
//       replace
//     />
//   );
// };

const ProtectedRoute = ({ allowedRoles = null }) => {
  const userRole = localStorage.getItem("userRole") || "";
  const normalizedUserRole = String(userRole).toLowerCase();
  const location = useLocation();

  const isAuthenticated = isSessionValid();
  const isAuthorized = allowedRoles
    ? allowedRoles
        .map((role) => String(role).toLowerCase())
        .includes(normalizedUserRole)
    : true;
  const brandRoles = ["brand", "brand-admin", "brand-staff"];
  const onboardingAllowedPaths = [
    "/brand-registration",
    "/complete-brand-profile",
    "/brand-representative-information",
  ];
  const brandOnboardingRequired =
    brandRoles.includes(normalizedUserRole) &&
    localStorage.getItem("brandOnboardingRequired") === "true";

  const needsOnboardingRedirect =
    isAuthenticated &&
    isAuthorized &&
    brandOnboardingRequired &&
    !onboardingAllowedPaths.includes(location.pathname);

  const redirectToMainHome =
    !isAuthenticated ||
    (!isAuthorized && location.pathname !== "/application-form");

  useEffect(() => {
    if (redirectToMainHome) {
      // A signed-in user whose session just ended goes to their own sign-in
      // page (which explains why); anyone else goes to the home page.
      window.location.replace(
        userRole && !isAuthenticated
          ? getSigninUrl(getSigninPath(userRole))
          : Config.SITE_URL
      );
    }
  }, [redirectToMainHome]);

  if (needsOnboardingRedirect) {
    const brandEmail = localStorage.getItem("Brand Email") || "";
    const signupStep = localStorage.getItem("signupStep");
    const resumePath =
      signupStep === "brand-representative-information"
        ? "/brand-representative-information"
        : "/complete-brand-profile";

    return (
      <Navigate
        to={`${resumePath}?brandEmail=${encodeURIComponent(
          brandEmail
        )}&resumeOnboarding=true`}
        replace
      />
    );
  }

  if (isAuthenticated && isAuthorized) {
    return <Outlet />;
  }

  if (location.pathname === "/application-form") {
    return <Navigate to="/influencer-login" replace />;
  }

  return null;
};

export default ProtectedRoute;
